import { useEffect, useState } from 'react'
import { Button } from '../../../../elements'

type OAuthFormProps = {
  webhookUrl?: string
  formatAuthorizationUrl: (webhookUrl: string) => string
}

export const OAuthForm = ({ webhookUrl, formatAuthorizationUrl }: OAuthFormProps) => {
  const [authorizationUrl, setAuthorizationUrl] = useState('')

  useEffect(() => {
    if (webhookUrl) {
      setAuthorizationUrl(formatAuthorizationUrl(webhookUrl))
    }
  }, [webhookUrl])

  return (
    <div className="grid gap-2">
      {!webhookUrl && (
        <div className="text-center">
          <p className="text-sm text-gray-11">Enable the channel first to continue with the next step</p>
        </div>
      )}
      <Button
        disabled={!webhookUrl}
        variant="primary"
        color="action"
        className="justify-center"
        onClick={() => window.open(authorizationUrl, 'OAuth', 'width=650,height=800,popup=true')}
      >
        Click here to authorize
      </Button>
    </div>
  )
}
